import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_ME } from '~/contexts/me/router/routes'

const ME_PROFILE_WEBSITE_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PROFILE_WEBSITE,
  path: 'website',
  component: () => import('~/contexts/me/pages/profile/index/website.vue'),
}

const ME_PROFILE_SKILL_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PROFILE_SKILL,
  path: 'skill',
  component: () => import('~/contexts/me/pages/profile/index/skill.vue'),
}

const ME_PROFILE_LANGUAGE_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PROFILE_LANGUAGE,
  path: 'language',
  component: () => import('~/contexts/me/pages/profile/index/language.vue'),
}

const ME_PROFILE_INTEREST_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PROFILE_INTEREST,
  path: 'interest',
  component: () => import('~/contexts/me/pages/profile/index/interest.vue'),
}

const ME_PROFILE_EXPERIENCE_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PROFILE_EXPERIENCE,
  path: 'experience',
  component: () => import('~/contexts/me/pages/profile/index/experience.vue'),
}

const ME_PROFILE_EDUCATION_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PROFILE_EDUCATION,
  path: 'education',
  component: () => import('~/contexts/me/pages/profile/index/education.vue'),
}

const ME_PROFILE_HOME_ROUTE: RouteRecordRaw = {
  name: ROUTE_ME.PROFILE_HOME,
  path: '',
  component: () => import('~/contexts/me/pages/profile/index/index.vue'),
}

export const ME_PROFILE_ROUTE: RouteRecordRaw = {
  path: 'profile',
  children: [
    ME_PROFILE_WEBSITE_ROUTE,
    ME_PROFILE_SKILL_ROUTE,
    ME_PROFILE_LANGUAGE_ROUTE,
    ME_PROFILE_INTEREST_ROUTE,
    ME_PROFILE_EXPERIENCE_ROUTE,
    ME_PROFILE_EDUCATION_ROUTE,
    ME_PROFILE_HOME_ROUTE,
  ],
  component: () => import('~/contexts/me/pages/profile/index.vue'),
  meta: { name: 'me-profile' },
}
